$ = require 'jquery'
Util = require 'lib/util'
View = require 'view'
entBoardDetails = require 'views/templates/ent_board_detail'

module.exports = class PublicBoardDetailView extends View
  viewTitleKey: 'board details'

  _convertToDateString: (date) ->
    (new Date(date)).toLocaleDateString(window.locale, { year: 'numeric', month: 'long', day: 'numeric' })

  render: ->
    board = @options.board
    boardModel = board.source
    boardAdminNames = boardModel.adminList.models.map((admin) => admin.get('fullName'))
    dateCreated = @_convertToDateString(Util.idToDate(board.id))
    dateLastActivity = if board.dateLastActivity
      @_convertToDateString(board.dateLastActivity)
    else
      null

    @$el.html(entBoardDetails(boardAdminNames, dateCreated, dateLastActivity, board.shortUrl))

    @



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/public-board-detail-view.coffee